import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default CatalogObjectSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    serviceChargeData: {
      embedded: 'always'
    }
  }
});